import React from 'react';
import Clear from '@material-ui/icons/Clear';
import { reactLoader, removeReactLoader } from "../../utils/common";
import WbHttpClient from './../../services/wbhttpclient';
import { withTranslation } from 'react-i18next';
import { Checkbox, Button, IconButton, ThemeProvider } from  '@workboard/wobo-ui'
import styled from 'styled-components';
import { krdetailConstants } from '../../constants/krdetails.constants';
import { DurationSelect } from './wizard/DurationSelect';



const StyledCheckbox = styled(Checkbox)`
  .MuiButtonBase-root {
    width: 24px;
    height: 24px;
    margin-left: -1px;
		padding: 0;
  }
  input{
    display: inline-block !important;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;

const StyledIconButton = styled(IconButton)`
  &.MuiButtonBase-root {
    width: 24px;
    height: 24px;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;

const DROPDOWN_DATE_FORMATS = ['MM/DD/YYYY', 'M/D/YYYY', 'YYYY-MM-DD'];
const UTC_DATE_FORMAT = 'YYYY-MM-DD';
const WARNING_STYLE = {
  fontSize: '12px',
  color: 'red',
  marginBottom: '10px',
  fontStyle: 'italic',
};

function namedPeriodTier(period) {
  if (!period) {
    return null;
  }
  if (period._isCustom || period.type === 5) {
    return 'custom';
  }
  if (period._isFullYear || period.type === 2) {
    return 'annual';
  }
  const label = period.quarter_name || period.name || '';
  if (/^H\d/i.test(label) || period.type === 4) {
    return 'half';
  }
  if (/^T\d/i.test(label) || period.type === 3) {
    return 'trimester';
  }
  if (/^Q\d/i.test(label) || period.type === 1) {
    return 'quarter';
  }
  return null;
}

function pickInitialDropdownOption(options, sourcePeriod) {
  if (!options || !options.length) {
    return null;
  }
  const selected = options.find(opt => opt.stats === 1);
  if (selected) {
    return selected;
  }
  const sourceTier = namedPeriodTier(sourcePeriod);
  if (sourceTier) {
    const match = options.find(opt => namedPeriodTier(opt) === sourceTier && !opt._isCustom);
    if (match) {
      return match;
    }
  }
  return options[0];
}

/**
 * Parse a date string, Date, or unix timestamp from dropdown/API into UTC date string (YYYY-MM-DD).
 * No timezone shifting - the calendar date is treated as UTC.
 */
function parseToUtcDateString(value) {
  if (value == null || value === '') return value;
  if (value instanceof Date) {
    return moment.utc([value.getFullYear(), value.getMonth(), value.getDate()]).format(UTC_DATE_FORMAT);
  }
  if (typeof value === 'number' && !Number.isNaN(value)) {
    return moment.unix(value).utc().format(UTC_DATE_FORMAT);
  }
  const m = moment.utc(value, DROPDOWN_DATE_FORMATS, true);
  return m.isValid() ? m.format(UTC_DATE_FORMAT) : value;
}

class CopyOKR extends React.Component {
  constructor(props) {
    super(props);
    this.wbHttpClient = new WbHttpClient();
    this.date_format = 'MMM DD, YYYY';
    this.dropdown_options = props.data.dropdown_options;
    this.warnings = false;

    const initialOption = pickInitialDropdownOption(this.dropdown_options, props.data.sourcePeriod)
      || this.dropdown_options[0];
    const initialStart = parseToUtcDateString(initialOption.start);
    const initialEnd = parseToUtcDateString(initialOption.end);

    this.initialTimePeriod = {
      name: initialOption.name,
      label: initialOption.name,
      start: moment.utc(initialStart).toISOString(),
      end: moment.utc(initialEnd).toISOString(),
      startDate: initialStart,
      endDate: initialEnd,
      fiscalYear: initialOption._isCustom ? undefined : initialOption.fiscalYear,
      _isCustom: !!initialOption._isCustom,
    };

    this.state = {
      data: props.data,
      key_results: {},
      start: initialStart,
      end: initialEnd,
      target_period: initialOption,
      date_error: '',
      save_error: ''
    }

    // Initialize key_results: mirrors and MIT parents must be unchecked when they cannot be copied
    props.data.metrics.forEach(metric => {
      this.state.key_results[`krcb-${metric.id}`] = this.canCopyKeyResult(
        metric,
        initialStart,
        initialEnd
      );
      // temporary fix to warn lack of support for cloning krstudio sources @see MSID 353
      if (metric.ext_app_id == 15) {
        this.warnings = true;
      }
    });

    this.submitHandler = this.submitHandler.bind(this);
    this.checkboxHandler = this.checkboxHandler.bind(this);
    this.getGoalMetadata = this.getGoalMetadata.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  submitHandler(e) {
    const { t } = this.props;
    const startMoment = moment.utc(this.state.start, UTC_DATE_FORMAT).startOf('day');
    const endMoment = moment.utc(this.state.end, UTC_DATE_FORMAT).startOf('day');
    if (endMoment.isBefore(startMoment) || endMoment.isSame(startMoment)) {
      this.setState({date_error: t('The selected end date cannot be earlier than the start date')});
      return;
    }

    let key_results = [], all_results = this.state.key_results;
    reactLoader();

    Object.keys(all_results).forEach(function(key, index) {
      if (all_results[key]) {
        let keyparts = key.split('-');
        key_results.push(parseInt(keyparts[1]));
      }
    });

    this.wbHttpClient.post('goal/cloneGoal', {
      goal_id: this.state.data.id,
      start: startMoment.unix(),
      end: endMoment.unix(),
      key_results: key_results
    }).then(response => {
      removeReactLoader();
      if ('undefined' !== typeof response.data) {
        if (response.data.statusCode === '200' && response.data.sts === 'ok') {
          const channel = new BroadcastChannel('okr:objectiveCopied');
          channel.postMessage(response.data.id);

          response.data.attribute.id = response.data.id;
          $('#copyGoalsBox').trigger('OKRcopied', response.data.attribute);
        } else {
          this.setState({
            save_error: response.data.errorMsg
          });
          console.log(response.data.errorMsg);
        }
      }
    });
  }

  checkboxHandler(e) {
    // Don't allow changes if the checkbox is disabled
    if (e.target.disabled) {
      return;
    }

    let key_results = {};
    key_results[e.target.name] = e.target.checked;

    this.setState({key_results: {...this.state.key_results, ...key_results}});
  }

  /**
   * Check if a metric is in the same timeperiod as the selected start/end dates
   * @param {Object} metric - The metric object
   * @param {string} start - Start date string
   * @param {string} end - End date string
   * @returns {boolean} - True if metric is in the same timeperiod, false otherwise
   */
  isMetricInSameTimeperiod(metric, start, end) {
    if(metric.source != krdetailConstants.SOURCE_MIRROR_KR) {
      return true;
    }
    const selectedStart = moment.utc(start, UTC_DATE_FORMAT).startOf('day').unix();
    const selectedEnd = moment.utc(end, UTC_DATE_FORMAT).startOf('day').unix();
    const metricStart = +metric.start_date;
    const metricEnd = +metric.end_date;

    // If metric doesn't have start/end dates, consider it compatible
    if (!metricStart || !metricEnd) {
      return true;
    }

    return metricStart === selectedStart && metricEnd === selectedEnd;
  }

  /**
   * Check if a metric is a multi-interval KR (source 12, 13, or 14)
   * @param {Object} metric - The metric object
   * @returns {boolean} - True if metric is a multi-interval KR, false otherwise
   */
  isMultiIntervalKR(metric) {
    const MIT_SOURCES = [12, 13, 14, "12", "13", "14"];
    return MIT_SOURCES.includes(metric.source);
  }

  /**
   * Get the type of date range (quarter or fiscal year)
   * @param {string} start - Start date string
   * @param {string} end - End date string
   * @returns {string} - 'quarter', 'fiscal_year', or 'other'
   */
  getDateRangeType(start, end) {
    const selectedStart = moment.utc(start, UTC_DATE_FORMAT);
    const selectedEnd = moment.utc(end, UTC_DATE_FORMAT);

    // Calculate the duration in months
    const durationInMonths = selectedEnd.diff(selectedStart, 'months', true);

    // Check if it's approximately 3 months (quarter) or 12 months (fiscal year)
    // Allow some tolerance for different month lengths
    const isQuarter = durationInMonths >= 2.5 && durationInMonths <= 3.5;
    const isFiscalYear = durationInMonths >= 11.5 && durationInMonths <= 12.5;

    if (isQuarter) {
      return 'quarter';
    } else if (isFiscalYear) {
      return 'fiscal_year';
    } else {
      return 'other';
    }
  }

  /**
   * Check if a multi-interval KR has a valid date combination
   * Multi-interval KRs can only be copied when both the original metric and selected dates are the same type
   * @param {Object} metric - The metric object
   * @param {string} start - Start date string
   * @param {string} end - End date string
   * @returns {boolean} - True if multi-interval KR has valid date combination, false otherwise
   */
  isMultiIntervalKRValid(metric, start, end) {
    if (!this.isMultiIntervalKR(metric)) {
      return true;
    }

    // Get the type of the selected date range
    const selectedRangeType = this.getDateRangeType(start, end);

    // Get the type of the original metric's date range
    const metricStart = +metric.start_date;
    const metricEnd = +metric.end_date;

    // If metric doesn't have start/end dates, consider it compatible
    if (!metricStart || !metricEnd) {
      return true;
    }

    const metricStartDate = moment.unix(metricStart).utc().format(UTC_DATE_FORMAT);
    const metricEndDate = moment.unix(metricEnd).utc().format(UTC_DATE_FORMAT);
    const metricRangeType = this.getDateRangeType(metricStartDate, metricEndDate);


    // Both ranges must be the same type (both quarter or both fiscal year)
    // OR the number of days between dates must match
    const metricDaysDiff = moment.unix(metricEnd).utc().diff(moment.unix(metricStart).utc(), 'days');
    const selectedDaysDiff = moment.utc(end, UTC_DATE_FORMAT).diff(moment.utc(start, UTC_DATE_FORMAT), 'days');

    // eslint-disable-next-line max-len
    return ( selectedRangeType !== "other" && selectedRangeType === metricRangeType) || (metricDaysDiff === selectedDaysDiff);
  }

  /**
   * Whether this KR can be included in the copy for the selected dates.
   * @param {Object} metric - The metric object
   * @param {string} start - Start date string
   * @param {string} end - End date string
   * @returns {boolean}
   */
  canCopyKeyResult(metric, start, end) {
    return this.isMetricInSameTimeperiod(metric, start, end)
      && this.isMultiIntervalKRValid(metric, start, end);
  }

  /**
   * Update key results checkboxes based on whether they are in the same timeperiod as the selected dates
   * @param {string} start - Start date string
   * @param {string} end - End date string
   */
  updateKeyResultsForTimeperiod(start, end) {
    const newKeyResults = {};

    this.state.data.metrics.forEach(metric => {
      const key = `krcb-${metric.id}`;
      if (!this.canCopyKeyResult(metric, start, end)) {
        newKeyResults[key] = false;
      } else {
        newKeyResults[key] = this.state.key_results[key] !== undefined ? this.state.key_results[key] : true;
      }
    });

    this.setState({
      key_results: newKeyResults
    });
  }

  /**
   * Key result dates only keep their position when the copy stays within the same period
   * tier (FY→FY, Q→Q, custom→custom, …). Crossing types (Custom to Quarter, Quarter to
   * Half year, …) takes the Objective timeframe.
   * @returns {boolean} - True when copying resets key result dates
   */
  willResetKeyResultDates() {
    const { data, target_period: targetPeriod } = this.state;
    const sourceTier = namedPeriodTier(data.sourcePeriod);
    const targetTier = namedPeriodTier(targetPeriod);
    const flexibleDatesEnabled = Boolean(window.wbConfig?.isFlexibleKrDatesEnabled);

    if (!flexibleDatesEnabled) {
      return false;
    }

    return sourceTier === null || targetTier === null || sourceTier !== targetTier;
  }

  handleKeyDown(event) {
    const ESC_KEY = 27;
    if (event.keyCode === ESC_KEY) {
      event.stopPropagation();
      this.closePopup();
    }
  }

  getGoalMetadata() {
    let metadata = '';

    if (this.state.data.team_name) {
      metadata += this.state.data.team_name + ' · ';
    }
    if (this.state.data.owner_name) {
      metadata += this.state.data.owner_name + ' · ';
    }

    let dates = moment.utc(this.state.start, UTC_DATE_FORMAT).format(this.date_format) + ' · ' + moment.utc(this.state.end, UTC_DATE_FORMAT).format(this.date_format);
    this.dropdown_options.forEach(item => {
      if (item.value !== this.dropdown_options[this.dropdown_options.length - 1].value // custom dates
        && parseToUtcDateString(item.start) === parseToUtcDateString(this.state.data.start)
        && parseToUtcDateString(item.end) === parseToUtcDateString(this.state.data.end)) {
        dates = item.name;
      }
    });

    return metadata + dates;
  }

  closePopup() {
    copyGoalsBox.off('OKRcopied');
    unmountCopyOKRDialog(null, 'copyGoalsBox');
    $('#copyGoalsBox').dialog('close');
  }

  render() {
    const { t } = this.props;
    const metadata = this.getGoalMetadata();
    const mirrorCopyWarning = t('Mirrors cannot be copied into different time periods');
    const mitCopyWarning = t(
      'Multi-interval key result children can only be copied when both the original and selected time periods are the same type (quarter to quarter or fiscal year to fiscal year).'
    );

    return (
      <ThemeProvider>
      <div className="copyOKR"
           tabIndex="0"
           onKeyDown={this.handleKeyDown}>
        <div className="cokr-title">
          <h3>{t('Copy and Reset OKR')}</h3>
          <StyledIconButton
            onClick={() => this.closePopup()}
            aria-label="Close"
          >
            <Clear />
          </StyledIconButton>
        </div>
        <div className="cokr-content">
          <div className="cokr-objective">
            {this.state.data.label}
          </div>
          <div className="cokr-description">
            {metadata}
          </div>
          <div className="metric-title">
            <div className="metric-label">{t('KEY RESULTS')}</div>
            <div className="metric-line"><hr /></div>
          </div>
          {this.state.data.metrics && this.state.data.metrics.some(metric => !this.isMetricInSameTimeperiod(metric, this.state.start, this.state.end)) && (
            <div className="kr-info" style={WARNING_STYLE}>
              {mirrorCopyWarning}
            </div>
          )}
          {this.state.data.metrics && this.state.data.metrics.some(metric => this.isMultiIntervalKR(metric) && !this.isMultiIntervalKRValid(metric, this.state.start, this.state.end)) && (
            <div className="kr-info" style={WARNING_STYLE}>
              {mitCopyWarning}
            </div>
          )}
          {this.willResetKeyResultDates() && (
            <div className="kr-info" style={WARNING_STYLE}>
              {t("Key result dates will be set to the new Objective's timeframe.")}
            </div>
          )}
          <div className="kr-list" data-testid="metric-list-test-id">
            {this.state.data.metrics &&
              this.state.data.metrics.map(metric => {
                const { start, end } = this.state;
                const isMirrorBlocked = !this.isMetricInSameTimeperiod(metric, start, end);
                const isMitBlocked = !this.isMultiIntervalKRValid(metric, start, end);
                const isDisabled = isMirrorBlocked || isMitBlocked;
                let disabledTitle;
                if (isMirrorBlocked) {
                  disabledTitle = mirrorCopyWarning;
                } else if (isMitBlocked) {
                  disabledTitle = mitCopyWarning;
                }

                return (
                  <div
                    className={`kr-row ${isDisabled ? 'kr-disabled' : ''}`}
                    key={`kr-${metric.id}`}
                    title={disabledTitle}
                  >
                    <div>
                      <StyledCheckbox
                        aria-labelledby={`kr-${metric.id}`}
                        isChecked={this.state.key_results[`krcb-${metric.id}`]}
                        onChange={this.checkboxHandler}
                        name={`krcb-${metric.id}`}
                        disabled={isDisabled}
                      />
                    </div>
                    <div className="kr-props">
                      <div className="kr-label">
                        <label id={`kr-${metric.id}`} style={{ opacity: isDisabled ? 0.6 : 1 }}>{metric.name}</label>
                      </div>
                      {(metric.child_kr_count > 0) && (
                        <div className="kr-children-count" style={{ opacity: isDisabled ? 0.6 : 1, fontSize: '12px', color: '#666', marginTop: '2px' }}>
                          + {metric.child_kr_count} children
                        </div>
                      )}
                      <div className="kr-description" style={{ opacity: isDisabled ? 0.6 : 1 }}>
                        {metric.owner_name} &middot; <span style={{color: metric.progress_color}}>{metric.current}</span>
                        {metric.end ? ` of ${metric.end}` : ``}
                      </div>
                    </div>
                  </div>
                );
              })
            }
          </div>
        </div>

        {!!this.state.save_error.length && (
          <div className="error-text" style={{padding: "0 17px 25px"}}>
            <span className="icon icon-outline-error_outline-14px-red"></span>
            <span className="error-text-msg">{this.state.save_error}</span>
          </div>
        )}

        <div className="cokr-calendar">
          <DurationSelect
            id="copy-okr-duration"
            config={{ enablePeriodFetch: true }}
            initialValue={this.initialTimePeriod}
            onChange={(data) => {
              const startUtc = parseToUtcDateString(data.start);
              const endUtc = parseToUtcDateString(data.end);
              this.setState({
                start: startUtc,
                end: endUtc,
                target_period: data,
                date_error: '',
              });
              this.updateKeyResultsForTimeperiod(startUtc, endUtc);
            }}
          />

        {this.state.date_error && (
          <div className="cokr-error">{this.state.date_error}</div>
        )}
        </div>
        <div className="cokr-disclaimer">
          * {t('Current key result progress and any alignment established will not be copied')}
        </div>
        <div className="cokr-footer">
          <Button variant="ghost" onClick={this.closePopup} className="close-link">{t('Cancel')}</Button>
          <Button variant="primary" onClick={(e) => this.submitHandler(e)} className="gbl-btn">{t('Copy and edit')}</Button>
        </div>
      </div>
      </ThemeProvider>
    );
  }
}

export default withTranslation()( CopyOKR );
